import React from "react";
import {Modal, Card, CardHeader, CardContent, Divider, Avatar} from "@material-ui/core";

const PersonPreviewModal = ({open, onClose, match, name}) => {
    if (!match) return null;

    // Family Office keys the url after its own contact column.
    const linkedinUrl = match.linkedin_profile_url || match.linkedin_url;
    // Bank & Trust sends the url flat; the other datasets send the uploader.
    const photoUrl = match.photo_url || match.photo?.url;

    return (
        <Modal open={open} onClose={onClose}>
            <Card style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                outline: 'none',
                maxHeight: '80%',
                overflowY: 'auto',
                width: '40%',
            }}>
                <CardHeader title='Person Preview'/>
                <CardContent>
                    {photoUrl && <Avatar src={photoUrl} alt={name} style={{width: 80, height: 80, marginBottom: 8}}/>}
                    <p><strong>Name:</strong> {name}</p>
                    {match.contact_crd_id && <p><strong>CRD ID:</strong> {match.contact_crd_id}</p>}
                    {linkedinUrl && <p><strong>LinkedIn:</strong> {linkedinUrl}</p>}
                    {match.gender && <p><strong>Gender:</strong> {match.gender}</p>}
                    {match.achievements?.length > 0 && (
                        <p><strong>Designations:</strong> {match.achievements.map(({name}) => name).join(', ')}</p>
                    )}
                    {match.existing_bt_contact_id && (
                        <p><strong>Already has a BT Contact record (ID: {match.existing_bt_contact_id})</strong></p>
                    )}
                    {match.universities?.length > 0 && (
                        <>
                            <Divider style={{margin: '8px 0'}}/>
                            <p><strong>Universities ({match.universities.length}):</strong></p>
                            {match.universities.map((u, i) => (
                                <p key={i}>
                                    {u.university_name}
                                    {u.start_year && ` (${u.start_year} - ${u.end_year || 'present'})`}
                                </p>
                            ))}
                        </>
                    )}
                    {match.companies?.length > 0 && (
                        <>
                            <Divider style={{margin: '8px 0'}}/>
                            <p><strong>Companies ({match.companies.length}):</strong></p>
                            {match.companies.map((c, i) => (
                                <p key={i}>
                                    {c.company_name}
                                    {c.start_year && ` (${c.start_year} - ${c.end_year || 'present'})`}
                                </p>
                            ))}
                        </>
                    )}
                </CardContent>
            </Card>
        </Modal>
    );
};

export default PersonPreviewModal;
